'use client';

import { FC, memo } from 'react';
import { DotButtonProps, DotsProps } from './types';
import clsx from 'clsx';
import styles from './EmblaDotButtons.module.css';

const DotButton: FC<DotButtonProps> = (props) => {
  const { children, className, active, onClick, dotClassName, ...restProps } = props;
  return (
    <button
      type="button"
      className={clsx(styles.embla__dot, className, { [styles.embla__dotActive]: active }, dotClassName)}
      onClick={onClick}
      data-active={active}
      {...restProps}
    >
      {children}
    </button>
  );
};

export const Dots: FC<DotsProps> = memo(({ emblaApi, scrollSnaps, selectedIndex, onclick, dotClassName }) => {
  if (!emblaApi) return null;
  return (
    <div className={styles.emblaDots}>
      {scrollSnaps.map((_, index) => (
        <DotButton
          key={index}
          active={index === selectedIndex}
          onClick={() => onclick(index)}
          dotClassName={dotClassName}
        />
      ))}
    </div>
  );
});
